var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessageGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#22313f;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-289 -5233)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(289 5233)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.125 5234.125)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8.484,
    y2: 8.484,
    transform: "translate(7.027 0.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.75,2,12.238,17.75l-3.15-7.087L2,7.513Z",
    transform: "translate(-2 -2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageGridIcon);
export default __webpack_public_path__ + "static/media/send-message-grid-icon.bb0d80171f8a6963029bc2b2eab8fdcd.svg";
export { ForwardRef as ReactComponent };